<template>
  <popover v-show="value" :name="name" :pointer="pointer" :width="width" :maxWidth="maxWidth" :event="event" :delay="delay" @show="value = $event.value">{{ $t(value) }}</popover>
</template>
<script>
export default {
  name: "Tooltip",
  props: {
    name: {
      type: String,
      default: "tooltip"
    },
    event: {
      type: String,
      default: "hover"
    },
    pointer: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 160
    },
    maxWidth: {
      type: [Number, String],
      default: 190
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: ""
    };
  }
};
</script>
